<ng-container *ngIf="!noLink">
    <a *ngIf="isLead"  [routerLink]="'/leads/show/' + clientId" [style.font-size]="fontSize + 'px'" style="cursor: pointer;" >{{firmenname}}</a>
    <a *ngIf="!isLead" [routerLink]="'/clients/show/' + clientId" [style.font-size]="fontSize + 'px'" style="cursor: pointer;" >{{firmenname}}</a>
</ng-container>
<ng-container *ngIf="noLink">
    <span [style.font-size]="fontSize + 'px'">{{firmenname}}</span>
</ng-container>
<ng-container *ngIf="showOrt">
    <span [style.font-size]="fontSize + 'px'"> / {{ort}}</span>
</ng-container>
<ng-container *ngIf="showNew">
    <mat-icon style="color: rgb(0, 68, 255)" *ngIf="newClient">fiber_new</mat-icon>
</ng-container>
